import { render, staticRenderFns } from "./OCategory.vue?vue&type=template&id=bdf1b3fe&scoped=true&"
import script from "./OCategory.vue?vue&type=script&lang=ts&"
export * from "./OCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf1b3fe",
  null
  
)

export default component.exports